import { t } from "@lingui/macro";
import { UseFormHandleSubmit } from "react-hook-form";

import { Button } from "@whoosh/design-system/src/components/controls";
import { Box, Text } from "@whoosh/design-system/src/components/primitive";

import { useFormProps } from "../types";

type SubmitButtonProps = {
  tosAgreed: boolean;
  isImageUploading: boolean;
  handleSubmit: UseFormHandleSubmit<useFormProps>;
  onSubmit: (formData: useFormProps) => void;
};

const SubmitButton = ({
  tosAgreed,
  isImageUploading,
  handleSubmit,
  onSubmit,
}: SubmitButtonProps) => {
  const showGray = !tosAgreed && !isImageUploading;
  return (
    <Box mb={6}>
      <Button
        onPress={handleSubmit(onSubmit)}
        testID="submit-btn"
        accessibilityLabel={t`Save Changes`}
        isDisabled={!tosAgreed || isImageUploading}
      >
        <Text
          color={showGray ? "grayscale-700" : "grayscale-0"}
          variant="mainBaseSemiBold"
          mx={6}
        >
          {t`Save Changes`}
        </Text>
      </Button>
    </Box>
  );
};

export default SubmitButton;
